import PostFetcher from './PostFetcher';

export default PostFetcher;